import { createAsyncThunk } from '@reduxjs/toolkit';
import { LogisticContractsApi } from '@/Api/LogisticContracts/LogisticContractsApi';
import { LogisticsApi } from '@/Api/Logistics/LogisticsApi';
import { OrderAddressValidationResponse } from '@/Api/Logistics/Responses/OrderAddressValidationResponse';
import { OrderAddressValidationRequest } from '@/Api/Logistics/Requests/OrderAddressValidationRequest';
import { ApplyAddressChangesResponse } from '@/Api/Logistics/Responses/ApplyAddressChangesResponse';
import { ApplyAddressChangesRequest } from '@/Api/Logistics/Requests/ApplyAddressChangesRequest';
import { GetOrderLogisticContractResponse } from '@/Api/LogisticContracts/Responses/GetOrderLogisticContractResponse';
import { GetOrderLogisticContractRequest } from '@/Api/LogisticContracts/Requests/GetOrderLogisticContractRequest';
import { GetOrdersWarehouseInfoResponse } from '@/Api/LogisticContracts/Responses/GetOrdersWarehouseInfoResponse';
import { GetOrdersWarehouseInfoRequest } from '@/Api/LogisticContracts/Requests/GetOrdersWarehouseInfoRequest';

const validateOrderAddresses = createAsyncThunk<OrderAddressValidationResponse, OrderAddressValidationRequest>(
  'shippingLabelModal/validate',
  async (request: OrderAddressValidationRequest) => {
    return LogisticsApi.validateOrdersAddresses(request);
  },
);

const applyAddressChanges = createAsyncThunk<ApplyAddressChangesResponse, ApplyAddressChangesRequest>(
  'shippingLabelModal/apply-address-changes',
  async (request: ApplyAddressChangesRequest) => {
    return LogisticsApi.applyAddressChanges(request);
  },
);

const getOrderLogisticContract = createAsyncThunk<GetOrderLogisticContractResponse, GetOrderLogisticContractRequest>(
  'orderAutomatization/get-order-logistic-contract',
  async (request) => {
    return LogisticContractsApi.getOrderLogisticContract(request);
  },
);

const getOrdersWarehouseInfo = createAsyncThunk<GetOrdersWarehouseInfoResponse, GetOrdersWarehouseInfoRequest>(
  'orderAutomatization/get-orders-warehouse-info',
  async (request) => {
    return LogisticContractsApi.getOrdersWarehouseInfo(request);
  },
);

export const asyncActions = {
  validateOrderAddresses,
  applyAddressChanges,
  getOrderLogisticContract,
  getOrdersWarehouseInfo,
};
